/*
	Hey there!

	This is the client file for your theme. If you need to do any client-side work in javascript,
	this is where it needs to go.

	You can listen for page changes by writing something like this:

	  $(window).on('action:ajaxify.end', function(data) {
		var	url = data.url;
		console.log('I am now at: ' + url);
	  });
*/

$(document).ready(function() {
	// Your code goes here
	socket.on('event:voted', updateRating);
	
	function updateRating(data) {
		var cl=data.post.votes>0 ? "green" : "red";
		var other_cl = data.post.votes>0 ? "red" : "green";
		var score=Math.min(5*Math.abs(data.post.votes),50);
		$('[data-pid="' + data.post.pid + '"] span.rating span.rating-' + cl).width(score);
		$('[data-pid="' + data.post.pid + '"] span.rating span.rating-' + other_cl).width(0);
	};
	
	$(window).on('action:ajaxify.end', function(data) {
			var topicContainer = $('.topic');
			topicContainer.on('click', '[component="topic/move-to-expired"]', function () {
				expireTopics(ajaxify.data.tid);
			});
			topicContainer.on('click', '[component="topic/move-to-expired-CSG"]', function () {
				expireCSGTopics(ajaxify.data.tid);
			});
			topicContainer.on('click', '[component="topic/move-to-hot-deals"]', function () {
				moveToHotDeals(ajaxify.data.tid);
			});
			topicContainer.on('click', '[component="topic/move-to-free-stuff"]', function () {
				moveToFreeStuff(ajaxify.data.tid);
			});
			//flags
			$('[data-action]').on('click', function () {
				var action = this.getAttribute('data-action');
				switch (action) {
					case 'appendNoteAndResolve':
						$('#attributes #state').val('resolved').attr('selected', 'selected');
						socket.emit('flags.update', {
							flagId: ajaxify.data.flagId,
							data: $('#attributes').serializeArray(),
						}, function (err) {
							if (err) {
								return app.alertError(err.message);
							}
							socket.emit('flags.appendNote', {
								flagId: ajaxify.data.flagId,
								note: document.getElementById('note').value,
							}, function (err, payload) {
								if (err) {
									return app.alertError(err.message);
								}
								app.alertSuccess('[[flags:note-added-and-resolved]]');
								//Flags.reloadNotes(payload.notes);
								//Flags.reloadHistory(payload.history);
							});
						});
				}
			});
	});
	function moveTopic(data, destCategoryName) {
		$(window).trigger('action:topic.move', data);

		socket.emit('topics.move', data, function (err) {
			if (err) {
				return app.alertError(err.message);
			}

			app.alertSuccess('[[topic:moved_to]] ' + destCategoryName);
		});
	}
	function expireCSGTopics(tid) {
		var data = {
			tids: [tid],
			cid: 36, //Expired CSG Deals
		};
		moveTopic(data, "[[topic:category_expired]]");
	}
	function expireTopics(tid) {
		var data = {
			tids: [tid],
			cid: 16, //Expired Deals
		};
		moveTopic(data, "[[topic:category_expired]]");
	}
	function moveToHotDeals(tid) {
		var data = {
			tids: [tid],
			cid: 6, //Hot Deals
		};
		moveTopic(data, "[[topic:category_HotDeals]]");
	}
	function moveToFreeStuff(tid) {
		var data = {
			tids: [tid],
			cid: 8, //Free Stuff
		};
		moveTopic(data, "[[topic:category_FreeStuff]]");
	}
});